module.exports = __webpack_public_path__ + "img/product-showcase-gallery-04.103a756f.jpg";